import { render, staticRenderFns } from "./List.vue?vue&type=template&id=f6964f2c&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=f6964f2c&prod&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=f6964f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6964f2c",
  null
  
)

export default component.exports